import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, Outlet, useLocation, useParams } from 'react-router-dom';
import { paths } from '@app/constants';
import { Namespace, useQuestionDetails } from '@data';
import { AntdCol, AntdInput, AntdRow, AntdTypography, AntdTabs } from '@ui/components';

const { Text } = AntdTypography;

const QuestionClassification = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation([Namespace.ADMIN]);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { questionId = '' } = useParams();
  const { data: question } = useQuestionDetails(questionId);

  const tabs = useMemo(
    () => [
      {
        label: t('question_page.classification.tab.icd_codes'),
        key: `/${paths.app}/${paths.questions_library.root}/${questionId}/${paths.questions_library.classification.root}/${paths.questions_library.classification.icd_codes}`,
      },
      {
        label: t('question_page.classification.tab.tags'),
        key: `/${paths.app}/${paths.questions_library.root}/${questionId}/${paths.questions_library.classification.root}/${paths.questions_library.classification.tags}`,
      },
      {
        label: t('question_page.classification.tab.starters'),
        key: `/${paths.app}/${paths.questions_library.root}/${questionId}/${paths.questions_library.classification.root}/${paths.questions_library.classification.starters}`,
      },
    ],
    [language, questionId],
  );

  return (
    <div className="pt-2 px-4 pb-8">
      <AntdRow gutter={24} className="mb-4">
        <AntdCol lg={12}>
          <Text>{t('question_page.classification.question')}</Text>
          <AntdInput value={question?.text} disabled className="mt-2" />
        </AntdCol>
      </AntdRow>

      <AntdTabs
        items={tabs}
        onChange={navigate}
        className="w-full [&>.ant-tabs-nav]:mb-0"
        activeKey={pathname}
        type="card"
      />

      <Outlet />
    </div>
  );
};

export default QuestionClassification;
